export enum ColorSpaceTypes {
  LCH = 'lch',
  SRGB = 'srgb',
  P3 = 'p3',
  HSL = 'hsl',
}
